import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { authorBlockPrintArticleArticle$key } from "scmp-app/queries/__generated__/authorBlockPrintArticleArticle.graphql";

import { Container, StyledAuthorNames, StyledDefaultArticleDate } from "./styles";

export type Props = {
  className?: string;
  firstNthAuthor?: number;
  reference: authorBlockPrintArticleArticle$key;
};

export const PrintArticleAuthorBlock: FunctionComponent<Props> = ({
  className,
  firstNthAuthor,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment authorBlockPrintArticleArticle on Article {
        ...defaultArticleDateContent
        ...authorNamesArticle
      }
    `,
    reference_,
  );

  if (!article) return null;

  return (
    <Container className={className}>
      <StyledAuthorNames firstNthAuthor={firstNthAuthor} reference={article} />
      <StyledDefaultArticleDate isEnableToggle={false} reference={article} />
    </Container>
  );
};

PrintArticleAuthorBlock.displayName = "PrintArticleAuthorBlock";
